import ApplicationController from "../../../application_controller"

const FIELD_SELECTOR = "input:not([type=hidden]):not([disabled]), textarea:not([disabled]), button[role=combobox]:not([disabled])"

export default class extends ApplicationController {
    static values = { autoOpen: Boolean, removeOnClose: Boolean, focusFirstField: Boolean }
    static targets = ["dialog"]

    pressedBackdrop = false

    connect() {
        super.connect()
        if (this.autoOpenValue) this.openModal()
    }

    openModal() {
        if (this.dialogTarget.open) return

        this.dialogTarget.showModal()
        this.focusInitialField()
    }

    // The browser focuses the [autofocus] field, or else the first control, which is the close button. In that case
    // move focus to the first field when asked, or to the panel so no focus ring shows on the close button.
    focusInitialField() {
        if (!document.activeElement?.closest("[data-modal-close]")) return

        const field = this.focusFirstFieldValue ? this.dialogTarget.querySelector(FIELD_SELECTOR) : null
        const target = field || this.dialogTarget
        target.focus()
    }

    closeModal() {
        this.dialogTarget.close()
    }

    // Close only when both press and release land on the backdrop, so dragging a text selection out of the
    // panel keeps it open. A press that dismisses an open select or date picker popover keeps it open too.
    rememberPress(event) {
        this.pressedBackdrop = this.onBackdrop(event) && !this.dialogTarget.querySelector(":popover-open")
    }

    closeOnBackdrop(event) {
        if (this.pressedBackdrop && this.onBackdrop(event)) this.closeModal()
        this.pressedBackdrop = false
    }

    onBackdrop(event) {
        if (event.target !== this.dialogTarget) return false

        const rect = this.dialogTarget.getBoundingClientRect()
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom
    }

    // Runs however the dialog closed: close button, backdrop, Escape or a form with method="dialog".
    closed() {
        if (!this.removeOnCloseValue) return

        const redirectUrl = this.element.closest("[data-modal-redirect-url]")?.dataset?.modalRedirectUrl
        const emptyDiv = document.createElement("div")
        if (this.element.id) emptyDiv.id = this.element.id
        this.element.replaceWith(emptyDiv)

        if (redirectUrl) window.location.href = redirectUrl
    }
}
